/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import type { ModelNode } from '../types';

export interface ExpandDatasetOptions {
  /** When set, wrap virtual SQL as subquery instead of Jinja macro. */
  virtualSql?: string;
}

/** Renders dataset node as Jinja macro or expanded virtual SQL subquery. */
export function expandDatasetNode(
  node: ModelNode,
  options: ExpandDatasetOptions = {},
): string {
  const id = node.ref.datasetId;
  if (id == null) {
    return '(\nSELECT 1 WHERE 1=0\n)';
  }
  if (options.virtualSql?.trim()) {
    return `(\n${options.virtualSql.trim()}\n) AS dataset_${id}`;
  }
  // Backend dataset() macro already returns "(…sql…) AS dataset_N"; joinCompiler adds table alias.
  return `{{ dataset(${id}) }}`;
}

/** @deprecated Use expandDatasetNode */
export function renderDatasetSubquery(node: ModelNode): string {
  return expandDatasetNode(node);
}
